/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : DisplayCustTypeCard.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Oct 10, 2019
*
* @Version      : Version 1.0
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 10, 2019
* Description  : Updated code as per ASDS-1471
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes. Icon Updated.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Dec 12, 2019
 * Description   : Updated icon to smaller icon
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - APU MSA UI changes
 *
 * By            : H422335
 * On            : Sept 24 2020
 * Description   : ASDS-3045 - APU Phase 2 UI Enhancements
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2

 ******************************************************************************/
import * as React from 'react';
import { Grid, Card, Button } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';
import CheckoutConstants from '../constants/checkout-constants';

function DisplayCustTypeCard(props) {
    return (
        <Card className="fullwidthCard config-confirmation-card-spacing">
            <Card.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={10} className="fullwidthRow">
                            <span className="confirmation-title-text">CUSTOMER CATEGORY</span>
                        </Grid.Column>
                        <Grid.Column width={2} className="fullwidthRow">
                            <div className="pull-right">
                            <Button  type="link" content="Reset" onClick={props.gotoCustomerCategoryTab}/>

                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12} className="custType">
                        <p className="confirmation-sub-text">{CheckoutConstants.CUSTOMER_CATEGORY_MSA === props.customerType ?
                        'MSA' : 'Non MSA'}</p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}

export default DisplayCustTypeCard;